import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders,  } from "@angular/common/http";
import { ConfigService } from "../shared/utils/config.service";
import { map } from "rxjs";
import { JwtHelperService } from '@auth0/angular-jwt';



@Injectable()
export class AdsService {

    baseUrl: string = '';
    userId : string = '';
    constructor(private http: HttpClient, private configService: ConfigService) {
        this.baseUrl = configService.getApiURI();
        let token = localStorage.getItem('token');
        let decodedToken = new JwtHelperService().decodeToken(token);
        this.userId = decodedToken?.sub
    };
    
    getPhotos() {
        return this.http.get(this.baseUrl + '/photo/')
            .pipe(map((res:any) => res.json()));

    }
    getAds(){
        let headers = new HttpHeaders();
        headers = this.configService.createHeader(headers)
        return this.http.get(this.baseUrl + '/ntadvertisement/GetAllAdvertisements',{ headers: headers })
            .pipe(map((res:any) => {
                return res;
            }));
    }

    AddAds(data){
        let headers = new HttpHeaders();
        headers = this.configService.createHeader(headers)
        return this.http.post(this.baseUrl + `/ntadvertisement/${this.userId}`, data,{ headers: headers })
    }

    editAds(data){
        let headers = new HttpHeaders();
        headers = this.configService.createHeader(headers)
        return this.http.post(this.baseUrl + `/ntadvertisement/${this.userId}/update`, data,{ headers: headers })
    }

    publishedAd(data: any){
        let headers = new HttpHeaders();
        headers = this.configService.createHeader(headers)
        return this.http.post(this.baseUrl +`/ntadvertisement/updatepublishedad/${this.userId}`, data , { headers: headers})
    }
    displayAd(data:any){
        let headers = new HttpHeaders();
        headers = this.configService.createHeader(headers)
        return this.http.post(this.baseUrl +`/ntadvertisement/updatedisplayad/${this.userId}`, data, { headers: headers }) 
    }

    getPhotosType(typeId: number) {
        return this.http.get(this.baseUrl + '/photo/' + typeId)
            .pipe(map((res:any) => res.json()));

    }

    upload(typeId: number, photo: any) {
        var formData = new FormData();
        formData.append('file', photo);

        return this.http.post(this.baseUrl + '/photo/' + typeId, formData)
            .pipe(map((res:any) => res.json()));
    }

    update(id: number) {
        return this.http.put(this.baseUrl + '/photo/' + id, id)
            .pipe(map((res:any) => res.json()));
    }

    updateChanges(ads: any) {
        return this.http.put(this.baseUrl + '/photo/link', ads)
            .pipe(map((res:any) => res.json()));
    }

    delete(id: number) {
        return this.http.delete(this.baseUrl + '/photo/' + id)
            .pipe(map((res:any) => res.json()));
    }

    change(typeId: number, eo: number, so: number) {
        return this.http.put(this.baseUrl + '/photo/' + typeId + '/' + eo + '/' + so, typeId)
            .pipe(map((res:any) => res.json()));

        //return this.http.get(this.baseUrl + '/photo/' + typeId)
        //    .pipe(map((res:any) => res.json()));
    }

}